import * as $ from 'jquery';
import { ArchiveItemCreate } from './ArchiveItemCreate';

$(() => {
    const archiveItemCreate = $('[data-archive-item-create]');
    if (archiveItemCreate.length === 0) {
        return;
    }

    let container = $(archiveItemCreate[0]);
    container.data('archiveItemCreate', new ArchiveItemCreate(container));
});
